/**
 * Extracts typed authorization bodies from a write-back `payload`.
 *
 * Delegates to {@link CandidAuthorizationWritebackPayload.parse}, which
 * unwraps the journal envelope and re-joins the per-CPT fan-out.
 *
 * @module getAuthorizationPayloads
 */
import { CandidAuthorizationWritebackPayload } from "../../../../../data-model/candidAuthorizationWritebackPayload";
import {
  CandidAuthorizationPayload,
  CandidWritebackRecord,
} from "../types/candidWriteback";

/**
 * Normalizes a write-back payload to a list of authorization cards.
 *
 * @param record - Write-back row whose `use_case` is authorization
 * @returns Authorization bodies posted on this row (possibly empty)
 */
export const getAuthorizationPayloads = (
  record: CandidWritebackRecord,
): CandidAuthorizationPayload[] => {
  if (!record.payload) {
    return [];
  }
  return CandidAuthorizationWritebackPayload.parse(record.payload);
};
